import { render, staticRenderFns } from "./NewTopic.vue?vue&type=template&id=b9b36330&lang=pug"
import script from "./NewTopic.vue?vue&type=script&lang=ts"
export * from "./NewTopic.vue?vue&type=script&lang=ts"
import style0 from "./NewTopic.vue?vue&type=style&index=0&id=b9b36330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports